import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SocialPage = () => {
  const [socialLinks, setSocialLinks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagePreview, setImagePreview] = useState("https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"); // State for the image preview
const [tempid,setTempid]=useState(null)
const location= useLocation()

  // Fetch user social links on page load
  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await axios.get(`https://hlinks-5xsm.onrender.com/api/:${location.pathname}`);

      
   
        if (response.data.success) {
       
              setImagePreview(response.data.socialLinks.profileImage); // Set image preview to base64 string
      setTempid(response.data.socialLinks.selectedTemplate)
          setSocialLinks(response.data.socialLinks);
        } else {
          setError(data.message);
        }
      } catch (err) {
   
        setError('Failed to fetch social links');
      } finally {
        setLoading(false);
      }
    };

    fetchSocialLinks();
  }, [location.pathname]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div id="mypfp">
     {
     tempid&&tempid==1?(
      <div className="profile-container">
      <h2>{socialLinks.name}</h2>
      <p className="short-title">{socialLinks.shortTitle}</p>
      <img src={imagePreview}  className="profile-image" alt="Profile" width={100} />

      <h3>Social Links:</h3>
      <ul className="social-links">
        {socialLinks.socialLinks.map((link, index) => (
          <li className=' my-3 fs-2 d-flex justify-content-center align-items-center' key={index}>
            <i className={link.icon}></i>
          
            <a href={link.link} className='mx-3 fs-5 w-75' target="_blank"  rel="noopener noreferrer">
            {link.platform}
            </a>
          </li>
        ))}
      </ul>
      
      <p className="vanity-link">{socialLinks.vanityLink}</p>
    </div>
     ):tempid&&tempid==2?(
      <div className="minimalist-template">
      {/* <div className="profile-section2"> */}
        <img src={imagePreview}alt="Profile" className="profile-img2" width={100}/>
        <h2 className="name2">{socialLinks.name}</h2>
        <p className="short-title2">"{socialLinks.shortTitle}"</p>
      {/* </div> */}

      <div className="social-links2">
        {socialLinks.socialLinks.map((link, index) => (
        <div className="social-links2-cont">
         <i className={link.icon}></i>
          <a key={index} href={link.link} className="social-icon2" target="_blank" rel="noopener noreferrer">
           {link.platform}
          </a>
          </div>
      
        ))}
      </div>

      <div  className="footname2">{socialLinks.vanityLink}
      </div>
    </div>
     ):tempid&&tempid==3?(
      <div className="social-link-template3">
      {/* Profile Section */}
      <div className="profile-section3">
        <img src={imagePreview} alt="Profile" className="profile-img3" />
        <h2 className="name3">{socialLinks.name}</h2>
        <p className="short-title3">{socialLinks.shortTitle}</p>
      </div>

      {/* Horizontal Social Links */}
      <div className="horizontal-social-icons3">
        {socialLinks.socialLinks.map((link, index)  => link.icon=="fab fa-instagram" ||link.icon=="fab fa-twitter" ||link.icon=="fab fa-facebook"?(
          <a key={index} href={link.link} target="_blank" rel="noopener noreferrer" className="social-icon3">
            <i className={link.icon}></i>
          </a>
        ):(null))}
      </div>

      {/* Vertical Links with Icon and Name */}
      <div className="vertical-links3">
        {socialLinks.socialLinks.map((link, index) => link.icon!=="fab fa-instagram" &&link.icon!=="fab fa-twitter" &&link.icon!=="fab fa-facebook"?(
          <div key={index} className="link-item3">
            <a href={link.link} target="_blank" rel="noopener noreferrer" className="link-icon3">
              <i className={link.icon}></i>
              
            </a>
            <a className="link-name3 " style={{textDecoration:"none"}} onClick={()=>window.location.href = link.link
}>{link.platform}</a>
            
          </div>
        ):(null))}
      </div>
    </div>
     ):(
     null
     )
     }
    </div>
  );
};

export default SocialPage;
